import { render } from "./upcoming-table.vue?vue&type=template&id=2e8348a6&lang=pug"
import script from "./upcoming-table.vue?vue&type=script&lang=js"
export * from "./upcoming-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__